<section class="articleSec">
  <div class="articleContainerFluid">
    <h1>
      Government of Pakistan Gifted Four Toyota Hiace Vans to Pakistan Sweet
      Home Children for Easy Travel
    </h1>
    <div class="articleTopDetails">
      <p class="articleDesc">
        Prime Minister Shehbaz Sharif and Interior Minister Rana Sanaullah
        donated four Toyota Hiace vans worth Rs 62 million to Pakistan Sweet
        Home.
      </p>
      <div class="articleTimeDetail">
        <p>June 30,2022</p>
        <p>.</p>
        <p>4 min read</p>
      </div>
    </div>
    <div class="articlePostingDetail">
      <div class="articlePostedBy">
        <img
          src="assets/new-images/articles/article-posted-by.png"
          alt="posted by"
        />
        <div class="posterDetails">
          <p class="posterName">Areeb Munawar Gill</p>
          <p class="posterPosition">Volunteer at Pakistan Sweet Home</p>
        </div>
      </div>
      <a href="javascript:;" class="articleShareBtn">
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_6301_3887)">
            <path
              d="M13.8133 11.4216C13.41 11.422 13.0133 11.5245 12.6603 11.7196C12.3073 11.9147 12.0095 12.196 11.7945 12.5372L5.48992 9.13721C5.60856 8.72049 5.60856 8.27893 5.48992 7.86221L11.7945 4.46221C12.1027 4.94737 12.5755 5.30502 13.1263 5.46941C13.677 5.6338 14.2685 5.59389 14.7922 5.35702C15.3158 5.12014 15.7364 4.70222 15.9766 4.18007C16.2167 3.65792 16.2604 3.06663 16.0994 2.51488C15.9385 1.96313 15.5838 1.48801 15.1006 1.17684C14.6174 0.865678 14.0381 0.739379 13.4692 0.821161C12.9003 0.902944 12.3801 1.18731 12.0041 1.622C11.6281 2.05668 11.4216 2.61247 11.4227 3.18721C11.4229 3.27436 11.4279 3.36143 11.4375 3.44805L4.98471 6.92774C4.66471 6.5611 4.24045 6.30085 3.7686 6.18177C3.29676 6.06268 2.79981 6.09043 2.34416 6.26131C1.8885 6.43218 1.49585 6.73805 1.21867 7.13803C0.941484 7.53802 0.792969 8.01307 0.792969 8.49971C0.792969 8.98635 0.941484 9.4614 1.21867 9.86138C1.49585 10.2614 1.8885 10.5672 2.34416 10.7381C2.79981 10.909 3.29676 10.9367 3.7686 10.8176C4.24045 10.6986 4.66471 10.4383 4.98471 10.0717L11.4375 13.5514C11.4279 13.638 11.4229 13.7251 11.4227 13.8122C11.4227 14.285 11.5629 14.7472 11.8256 15.1404C12.0882 15.5335 12.4616 15.8399 12.8984 16.0209C13.3353 16.2018 13.8159 16.2491 14.2797 16.1569C14.7434 16.0647 15.1694 15.837 15.5037 15.5026C15.838 15.1683 16.0657 14.7423 16.158 14.2786C16.2502 13.8149 16.2029 13.3342 16.0219 12.8974C15.841 12.4605 15.5346 12.0872 15.1414 11.8245C14.7483 11.5618 14.2861 11.4216 13.8133 11.4216ZM13.8133 1.85908C14.076 1.85908 14.3327 1.93697 14.5511 2.08291C14.7696 2.22885 14.9398 2.43627 15.0403 2.67895C15.1408 2.92164 15.1671 3.18868 15.1159 3.44631C15.0646 3.70394 14.9382 3.94059 14.7524 4.12633C14.5667 4.31207 14.33 4.43857 14.0724 4.48981C13.8148 4.54106 13.5477 4.51476 13.305 4.41423C13.0623 4.31371 12.8549 4.14348 12.709 3.92507C12.5631 3.70666 12.4852 3.44988 12.4852 3.18721C12.4856 2.83509 12.6256 2.49753 12.8746 2.24855C13.1236 1.99957 13.4612 1.8595 13.8133 1.85908ZM3.18828 9.82783C2.9256 9.82783 2.66883 9.74994 2.45042 9.604C2.23201 9.45807 2.06178 9.25064 1.96126 9.00796C1.86073 8.76528 1.83443 8.49823 1.88568 8.2406C1.93692 7.98297 2.06342 7.74632 2.24916 7.56058C2.4349 7.37484 2.67155 7.24835 2.92918 7.1971C3.18681 7.14585 3.45385 7.17216 3.69653 7.27268C3.93922 7.3732 4.14664 7.54343 4.29258 7.76184C4.43852 7.98025 4.51641 8.23703 4.51641 8.49971C4.51599 8.85182 4.37592 9.18939 4.12694 9.43837C3.87796 9.68735 3.54039 9.82741 3.18828 9.82783ZM13.8133 15.1403C13.5506 15.1403 13.2938 15.0624 13.0754 14.9165C12.857 14.7706 12.6868 14.5631 12.5863 14.3205C12.4857 14.0778 12.4594 13.8107 12.5107 13.5531C12.5619 13.2955 12.6884 13.0588 12.8742 12.8731C13.0599 12.6873 13.2965 12.5608 13.5542 12.5096C13.8118 12.4584 14.0789 12.4847 14.3215 12.5852C14.5642 12.6857 14.7716 12.8559 14.9176 13.0743C15.0635 13.2927 15.1414 13.5495 15.1414 13.8122C15.141 14.1643 15.0009 14.5019 14.7519 14.7509C14.503 14.9998 14.1654 15.1399 13.8133 15.1403Z"
              fill="#201F1F"
            />
          </g>
          <defs>
            <clipPath id="clip0_6301_3887">
              <rect width="17" height="17" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span>Share</span>
      </a>
    </div>
    <img
      class="articleBannerImg"
      src="assets/new-images/articles/government-of-pakistan-gifted-four-toyota-hiace-vans.png"
      alt="banner img"
    />

    <div class="articleContentWrapper">
      <p>
        In a heartwarming act of kindness, Prime Minister Shehbaz Sharif, along
        with Interior Minister Rana Sanaullah, paid a visit to Pakistan Sweet
        Home. During this visit, the Prime Minister generously donated four
        brand new Toyota Hiace vans worth Rs 62 million. These vans will be used
        to facilitate the children living in Pakistan Sweet Home, making it
        easier and more convenient for them to go to school and on educational
        trips. The amazing Patron in Chief of Pakistan Sweet Home, Zamurrad Khan
        (Hilal-e-Imtiaz), had the privilege of personally receiving the keys to
        these vans from the prime minister.
      </p>
      <img src="assets/new-images/articles/psh-van.png" alt="PSH van" />
      <h2>Prime Minister Sharif Engages with Students</h2>
      <p>
        Prime Minister Shebaz Sharif had a fantastic time interacting with the
        bright young minds at Pakistan Sweet Home Cadet College. He emphasized
        the importance of hard work and gaining knowledge that is relevant to
        today's world. He recognized the students as the "real future of the
        country" and expressed his strong belief in their potential to make
        positive contributions to their homeland. He encouraged them to explore
        various fields like medicine, engineering, scientific research,
        agriculture, and information technology. Moreover, he provided valuable
        guidance on potential career paths they could consider. Prime Minister
        praised Zamurrad Khan for his unwavering dedication in caring for orphan
        children at Pakistan Sweet Home. Khan's tireless efforts to give these
        young
      </p>
      <img
        src="assets/new-images/articles/inside-psh-van.png"
        alt="inside PSH van"
      />
      <h2>Prime Minister Sharif Joins Joyful Ride with Students</h2>
      <p>
        Prime Minister Sharif, accompanied by the students, took a ride in one
        of the newly donated vans. The air was filled with the joyful voices of
        the children as they chanted slogans of "Pakistan Zindabad" (Long Live
        Pakistan), expressing their gratitude for the government's support and
        the sense of belonging they felt.
      </p>
      <img
        src="assets/new-images/articles/inside-psh-van2.png"
        alt="inside PSH van"
      />
      <h2>A Commitment for a Brighter Future</h2>
      <p>
        The Prime Minister's visit to Pakistan Sweet Home showcases the
        government's commitment to improving the lives of those in need. It has
        brought a sense of belonging, hope, and reassurance to Pakistan Sweet
        Home, reminding us all that every child deserves a brighter future.
      </p>
      <h2>Joint Efforts Transform Lives at Pakistan Sweet Home</h2>
      <p>
        Pakistan Sweet Home extends its heartfelt gratitude to Prime Minister
        Shehbaz Sharif for his invaluable support and donation. His visit and
        generous contribution have reaffirmed the organization's mission of
        providing a nurturing and caring environment for orphan children. With
        the joint efforts of individuals like the Prime Minister and Zamurrad
        Khan, Pakistan Sweet Home continues to make a positive impact on the
        lives of these children, enabling them to flourish and become productive
        members of society.
      </p>
    </div>
  </div>
</section>
